import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { getApiUrl } from '../../config/api';

const ApiTestSimple = () => {
  const [results, setResults] = useState({});
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const testApis = async () => {
      const tests = {
        gold: 'http://localhost:5000/gold',
        feature: 'http://localhost:5000/feature',
        everyday: 'http://localhost:5000/everyday',
        best: 'http://localhost:5000/best',
        categories: 'http://localhost:5000/category/getAllCategory',
        goldPrice: 'http://localhost:5000/today-price/PriceRouting',
        cart: 'http://localhost:5000/cart/68ded148cbfe892dc87f3c45'
      };

      const results = {};
      
      for (const [name, url] of Object.entries(tests)) {
        try {
          console.log(`Testing ${name}: ${url}`);
          const response = await axios.get(url);
          results[name] = {
            status: 'success',
            statusCode: response.status,
            dataLength: response.data ? (Array.isArray(response.data) ? response.data.length : Object.keys(response.data).length) : 0,
            data: response.data
          };
          console.log(`${name} success:`, response.data);
        } catch (err) {
          results[name] = {
            status: 'error',
            error: err.message,
            statusCode: err.response?.status
          };
          console.error(`${name} error:`, err);
        }
      }
      
      setResults(results);
      setLoading(false);
    };

    testApis();
  }, []);

  if (loading) return <div className="p-4">Testing APIs...</div>;

  return (
    <div className="p-4">
      <h1 className="text-2xl font-bold mb-4">API Test Results</h1>
      <div className="space-y-4">
        {Object.entries(results).map(([name, result]) => (
          <div key={name} className={`p-4 rounded ${result.status === 'success' ? 'bg-green-100' : 'bg-red-100'}`}>
            <h3 className="font-bold text-lg">{name.toUpperCase()}</h3>
            <p>Status: {result.status}</p>
            {result.statusCode && <p>HTTP Status: {result.statusCode}</p>}
            {result.dataLength && <p>Data Length: {result.dataLength}</p>}
            {result.error && <p className="text-red-600">Error: {result.error}</p>}
            {result.data && (
              <details className="mt-2">
                <summary className="cursor-pointer">View Data</summary>
                <pre className="mt-2 p-2 bg-gray-100 rounded text-xs overflow-auto">
                  {JSON.stringify(result.data, null, 2)}
                </pre>
              </details>
            )}
          </div>
        ))}
      </div>
    </div>
  );
};

export default ApiTestSimple;
